<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Vessel Certificate Category &nbsp;
          <save-button @click="save"></save-button>
          <small v-if="isSaving">Saving...</small>
          <!-- <add-button link="/values/create"></add-button> -->
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Safety Management</li>
          <li class="breadcrumb-item">Vessel Certificate Category</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->

    <!-- Table -->
    <div class="row">
      <div class="col-md-6 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div id="buttons">
              <button
                class="btn btn-inverse-primary btn-sm"
                @click="create_parent_node()"
              >
                New Item
              </button>
              &nbsp; &nbsp;
              <button
                v-if="selectedNode"
                class="btn btn-inverse-success btn-sm"
                @click="create_new_node(selectedNode)"
              >
                Sub Item
              </button>
              &nbsp; &nbsp;
              <button
                v-if="selectedNode"
                class="btn btn-inverse-warning btn-sm"
                @click="edit_existing_node(selectedNode)"
              >
                Edit
              </button>
              &nbsp; &nbsp;
              <button
                v-if="selectedNode"
                class="btn btn-inverse-danger btn-sm"
                @click="Delete_Node(selectedNode)"
              >
                Delete
              </button>
            </div>
            <br />
            <v-treeview
              v-model="treeData"
              :treeTypes="treeTypes"
              @selected="selected"
              :openAll="openAll"
              :contextItems="contextItems"
              @contextSelected="contextSelected"
            ></v-treeview>
            <br />
          </div>
        </div>
      </div>
      <div class="col-md-6 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Add New Parent -->
            <div v-if="editor_display == 1">
              <label for="New Parent">New Item</label>
              <input
                type="text"
                ref="add_parent"
                class="form-control"
                :class="[
                  is_existing == true || is_blank == true
                    ? 'is-invalid'
                    : 'is-valid',
                ]"
                placeholder="Name..."
                v-model="text"
                @keydown.enter="addParent(text)"
              />
            </div>
            <!--/ Add New Parent -->
            <!-- Adding Sub Items -->
            <div v-if="editor_display == 2">
              <label for="Sub Item">Sub Item</label>
              <input
                type="text"
                class="form-control"
                :class="[
                  is_existing == true || is_blank == true
                    ? 'is-invalid'
                    : 'is-valid',
                ]"
                placeholder="Name..."
                v-model="empty_node.text"
                @keydown.enter="add_node(current_node, empty_node)"
              />
            </div>
            <!--/ Adding Sub Items -->
            <!-- Edit Existing Items -->
            <div v-if="editor_display == 3">
              <label for="Edit Item">Edit Item</label>
              <input
                type="text"
                class="form-control"
                placeholder="Name..."
                :class="[
                  is_existing == true || is_blank == true
                    ? 'is-invalid'
                    : 'is-valid',
                ]"
                v-model="text"
                @keydown.enter="edited_node(current_node, text)"
              />
            </div>
            <!--/ Edit Existing Items -->
            <!-- Error Message -->
            <div class="alert alert-danger" v-show="is_existing" role="alert">
              <i data-feather="alert-circle"></i>
              <label for="Duplicate Entries" class=""
                >Duplicated Entries Found</label
              >
            </div>
            <div class="alert alert-danger" v-show="is_blank" role="alert">
              <i data-feather="alert-circle"></i>
              <label for="Blank Entries"
                ><strong>this field is required</strong></label
              >
            </div>
            <!--/ Error Message -->
            <div
              class="alert alert-success"
              role="alert"
              v-show="submitStatus == 'OK'"
            >
              <h4 class="alert-heading">Items added to Tree Successfully</h4>
              Now Click the <i data-feather="save"></i>button on Top to save the
              latest Tree
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
    <!-- Table -->
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";
import VTreeview from "v-treeview";
// const ADD_PARENT = 1;
const ADD_CHILD = 2;
const EDIT_NODE = 3;
// Delete Node
const filterObject = (object, id) => {
  const newObj = [];
  object.map((element) => {
    if (parseInt(element.id) === parseInt(id)) return;
    if (element.items) element.items = filterObject(element.items, id);
    if (element.children) element.children = filterObject(element.children, id);
    newObj.push(element);
  });
  return newObj;
};
export default {
  name: "Values",
  data() {
    return {
      openAll: false,
      form: {
        value_id: "",
        company_id: "",
      },
      treeTypes: [
        {
          type: "#",
          valid_children: ["PARENT"],
        },
        {
          type: "PARENT",
          icon: "far fa-user",
          valid_children: ["CHILD"],
        },
        {
          type: "CHILD",
          icon: "far fa-hospital",
          valid_children: ["CHILD"],
        },
      ],
      // Tree data For treeview
      treeData: [],
      //Json For Backend
      json_data: [],
      json_data_string: [],
      // RAW JSON for Validation
      RawData: [],

      value_list: [],
      valueLists: [],
      contextItems: [],
      selectedNode: null,
      current_node: null,

      isLoading: false,
      isSaving: false,

      editor_display: false,
      is_existing: false,
      is_blank: false,
      text: "",
      submitStatus: "PENDING",
    };
  },
  mounted() {
    this.getData();
  },
  components: {
    VTreeview,
  },
  methods: {
    // Open Parent Node
    create_parent_node() {
      // For Display Add Parent Item
      this.editor_display = true;
      // For Empty Current Node
      this.current_node = null;
      // For Empty Name Field
      this.text = "";
    },
    // Get Validation
    async get_validate() {
      this.json_data = this.RawData;
      this.json_data_string = JSON.stringify(this.json_data);
      let is_existing = await axios.get(
        `value_lists/check_unique_json_code?json_data=${this.json_data_string}`
      );
      this.is_existing = is_existing.data.Found;
      return this.is_existing;
    },
    // Delete Node
    Delete_Node(node) {
      // Remove Child
      this.RawData = filterObject(this.RawData, node.model.id);
      this.treeData = this.RawData;
    },
    // Add Parent
    async addParent(text) {
      // Validation
      this.is_existing = false;
      // If TEXT is not Null
      if (text != "" && text != null) {
        this.is_blank = false;
        // creating Random Ids
        let checked_id = Math.round(Math.random() * 100000);
        // creating a New Parent Node
        let node = {
          id: checked_id,
          text: text,
          name: text,
          code: text,
          type: "PARENT",
          children: [],
          items: [],
        };
        // Pushing the Newly Created Node in the rawData For Validation
        this.RawData.push(node);
        // Validation Part
        await this.get_validate();
        if (this.is_existing == false) {
          // Pushing the Newly Created Node in the Main Tree Data
          this.treeData.push(node);
          if (this.valueLists.length > 0) {
            let selectedRAWNode = this.searchNode(node.id, this.RawData);
            // Remove Duplicate Node if Exist from RawData
            this.RawData.splice(this.RawData.indexOf(selectedRAWNode), 1);
            this.treeData = this.RawData;
          }
          // After Pushing Empty the text Field
          this.text = null;
          // After Everything Hide the Text field
          this.editor_display = false;
          // Show Success Message
          this.submitStatus = "OK";
          setTimeout(() => {
            // Hide Success Message in 3 Sec
            this.submitStatus = "PENDING";
          }, 3000);
        } else {
          // Remove Currently Added Node from RawData
          this.RawData.splice(this.RawData.indexOf(node), 1);
        }
      } else {
        this.is_blank = true;
      }
    },
    // Opens New Form For Adding New Child
    create_new_node(current_node) {
      this.editor_display = ADD_CHILD;
      this.selectedNode = current_node;
      // Make currently selected Node Blank
      this.current_node = null;
      // Redefining
      this.current_node = current_node.model;
      // creating Random Ids
      let checked_id = Math.round(Math.random() * 100000);
      // Create an Empty Node
      this.empty_node = {
        id: checked_id,
        text: "",
        name: "",
        code: "",
        type: "CHILD",
        children: [],
        items: [],
      };
    },
    // Add a new Child
    async add_node(current_node, child_node) {
      // Validation
      this.is_existing = false;
      // Make currently selected Node Blank
      this.current_node = null;
      // Redefining
      this.current_node = current_node;
      // If TEXT is not Null
      if (Object.keys(child_node["text"]).length != 0) {
        this.is_blank = false;

        // Assigning Code & Name
        child_node["name"] = child_node["text"];
        child_node["code"] = child_node["text"];
        // Search the Exact Node in RawData
        let selectedRAWNode = this.searchNode(current_node.id, this.RawData);
        // Add node in RAW Data
        selectedRAWNode.items.push(child_node);
        // Validation Part
        await this.get_validate();
        if (this.is_existing == false) {
          // Push the Newly Created Node in Current Node
          this.current_node.children.push(child_node);
          // Hide Editor
          this.editor_display = false;
          // Show Success Message
          this.submitStatus = "OK";
          setTimeout(() => {
            // Hide Success Message in 3 Sec
            this.submitStatus = "PENDING";
          }, 3000);
        } else {
          // Remove Currently Added Node from RawData
          selectedRAWNode.items.splice(
            selectedRAWNode.items.indexOf(child_node),
            1
          );
        }
      } else {
        this.is_blank = true;
      }
    },
    // Opens Edit Form
    edit_existing_node(node) {
      this.editor_display = EDIT_NODE;
      this.current_node = null;
      this.current_node = node.model;
      this.text = node.model.text;
    },
    // Save the Edited Entry
    async edited_node(node, text) {
      // Validation
      this.is_existing = false;
      // If TEXT is not Null
      if (text != "" && text != null) {
        this.is_blank = false;
        // Make currently selected Node Blank
        this.current_node = null;
        // Search the Exact Node in RawData
        let selectedRAWNode = this.searchNode(node.id, this.RawData);
        node["name"] = text;
        node["code"] = text;
        node["text"] = text;
        selectedRAWNode = node;
        // Redefining
        this.current_node = node;
        // Validation Part
        await this.get_validate();
        if (this.is_existing == false) {
          // Make currently selected Node Blank
          this.current_node = null;
          // Hide Editor
          this.editor_display = false;
          // Show Success Message
          this.submitStatus = "OK";
          setTimeout(() => {
            // Hide Success Message in 3 Sec
            this.submitStatus = "PENDING";
          }, 3000);
        } else {
          // Remove Currently Added Node from RawData
          selectedRAWNode.splice(selectedRAWNode.indexOf(node), 1);
        }
      } else {
        this.is_blank = true;
      }
    },
    // Search Node Using ID in Recursion
    searchNode(id, currentNode) {
      var result;
      for (const [key, value] of Object.entries(currentNode)) {
        if (key == "id" && value == id) return currentNode;
        if (value !== null && typeof value === typeof []) {
          result = this.searchNode(id, value);
          if (result) {
            return result;
          }
        }
      }
    },
    // -----------FOR COMPONENT-------------------------------------------------------------------------------------------------------------
    getTypeRule(type) {
      var typeRule = this.treeTypes.filter((t) => t.type == type)[0];
      return typeRule;
    },
    contextSelected(command) {
      switch (command) {
        case "Create CHILD":
          var node = {
            text: "New Sub Item",
            type: "CHILD",
            children: [],
            items: [],
          };
          this.selectedNode.addNode(node);
          this.selectedNode.open = true;
          break;
        case "Create Top-up":
          node = {
            text: "New Top-up",
            type: "Top-up",
            children: [],
          };
          this.selectedNode.addNode(node);
          break;
        case "Rename":
          this.selectedNode.editName();
          break;
        case "Remove":
          break;
      }
      this.selectedNode = null;
    },
    selected(node) {
      this.selectedNode = node;
    },
    // -----------FOR BACKEND-------------------------------------------------------------------------------------------------------------
    // Get Data
    async getData(page = 1) {
      this.ExportValueLists = [];
      this.isLoading = true;
      let masters = await axios.get("value_lists/masters");
      masters = masters.data;
      masters.values.forEach((value) => {
        if (
          value.name == "Vessel Certificate Category" &&
          value.category == "Safety Management"
        ) {
          // let value_id = value.id;
          this.form.value_id = value.id;
        }
      });
      this.form.company_id = this.company.id;
      let valueLists = await axios.get(
        `/values/${this.form.value_id}/value_lists`
      );
      this.valueLists = valueLists.data.data;
      if (this.valueLists.length > 0) {
        this.value_list = this.valueLists[0];
        this.treeData = this.value_list.json_data;
        this.RawData = this.value_list.json_data;
      }
      this.count = valueLists.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    // Save the tree to Database
    async save() {
      this.json_data = this.RawData;
      if (this.json_data.length > 0) {
        this.isSaving = true;
        this.form.json_data = this.json_data;
        let response = "";
        if (Object.keys(this.value_list).length != 0) {
          // FOR UPDATE
          response = await axios.patch(
            `/values/${this.form.value_id}/value_lists/${this.value_list.id}`,
            this.form
          );
        } else {
          // FOR ADD
          response = await axios.post(
            `/values/${this.form.value_id}/value_lists`,
            this.form
          );
        }
        this.value_list = response.data.data;
        this.isSaving = false;
      }
    },
  },
};
</script>
